const QUESTION_DELETED_EVENT = "questionDeleted";
const QUESTION_ADDED_EVENT = "questionAdded";

const STORE_TYPES = [
  "bigc",
  "jiffy",
  "tops",
  "lotus",
  "maxmart",
  "seven_eleven",
  "ws",
  "gt",
  "lamp",
  "unknown",
];
const KA_STORE_TYPES = Object.freeze(
  STORE_TYPES.filter((type) =>
    ["bigc", "jiffy", "tops", "lotus", "maxmart", "seven_eleven"].includes(
      type,
    ),
  ),
);
const KA_AUDIENCE_TYPES = KA_STORE_TYPES;
const VOLUME_TARGET_RAW_ONLY_AUDIENCE_TYPES = Object.freeze([
  ...KA_AUDIENCE_TYPES,
  "ws",
]);

export {
  QUESTION_DELETED_EVENT,
  QUESTION_ADDED_EVENT,
  STORE_TYPES,
  KA_STORE_TYPES,
  KA_AUDIENCE_TYPES,
  VOLUME_TARGET_RAW_ONLY_AUDIENCE_TYPES,
};
